import React, { useEffect, useRef } from 'react';
import './Zsbzs.css';

const Zsbzs = () => {
  const containerRef = useRef(null);
  const textsRef = useRef([]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // 创建多个文字元素
    const textCount = 25;
    const texts = [];

    for (let i = 0; i < textCount; i++) {
      const textElement = document.createElement('div');
      textElement.className = 'floating-text';
      textElement.textContent = 'zsb&&cms';
      
      // 随机样式
      const fontSize = Math.random() * 80 + 30; // 30-110px
      const color = `hsl(${Math.random() * 360}, ${70 + Math.random() * 30}%, ${40 + Math.random() * 30}%)`;
      
      textElement.style.fontSize = `${fontSize}px`;
      textElement.style.color = color;
      textElement.style.left = `${Math.random() * (window.innerWidth - 300)}px`;
      textElement.style.top = `${Math.random() * (window.innerHeight - 150)}px`;
      
      // 随机速度和方向
      const speed = Math.random() * 3 + 1;
      const angle = Math.random() * Math.PI * 2;
      const speedX = Math.cos(angle) * speed;
      const speedY = Math.sin(angle) * speed;
      
      textElement.speedX = speedX;
      textElement.speedY = speedY;
      textElement.mass = fontSize / 50; // 质量与字体大小相关
      
      container.appendChild(textElement);
      texts.push(textElement);
    }

    textsRef.current = texts;

    // 碰撞检测函数
    const checkCollision = (text1, text2) => {
      const rect1 = text1.getBoundingClientRect();
      const rect2 = text2.getBoundingClientRect();
      
      const centerX1 = rect1.left + rect1.width / 2;
      const centerY1 = rect1.top + rect1.height / 2;
      const centerX2 = rect2.left + rect2.width / 2;
      const centerY2 = rect2.top + rect2.height / 2;
      
      const distance = Math.sqrt(
        Math.pow(centerX2 - centerX1, 2) + Math.pow(centerY2 - centerY1, 2)
      );
      
      const minDistance = (rect1.width + rect2.width) / 4;
      
      return distance < minDistance;
    };

    // 处理碰撞
    const handleCollision = (text1, text2) => {
      // 计算碰撞后的速度（简化的弹性碰撞）
      const m1 = text1.mass;
      const m2 = text2.mass;
      
      const v1x = text1.speedX;
      const v1y = text1.speedY;
      const v2x = text2.speedX;
      const v2y = text2.speedY;
      
      // 新速度计算
      const newV1x = ((m1 - m2) * v1x + 2 * m2 * v2x) / (m1 + m2);
      const newV1y = ((m1 - m2) * v1y + 2 * m2 * v2y) / (m1 + m2);
      const newV2x = ((m2 - m1) * v2x + 2 * m1 * v1x) / (m1 + m2);
      const newV2y = ((m2 - m1) * v2y + 2 * m1 * v1y) / (m1 + m2);
      
      text1.speedX = newV1x * 0.9; // 添加一些能量损失
      text1.speedY = newV1y * 0.9;
      text2.speedX = newV2x * 0.9;
      text2.speedY = newV2y * 0.9;
      
      // 碰撞效果
      text1.style.color = `hsl(${Math.random() * 360}, 80%, 60%)`;
      text2.style.color = `hsl(${Math.random() * 360}, 80%, 60%)`;
      
      // 添加碰撞动画
      text1.style.transform = 'scale(1.3)';
      text2.style.transform = 'scale(1.3)';
      
      setTimeout(() => {
        text1.style.transform = 'scale(1)';
        text2.style.transform = 'scale(1)';
      }, 200);
    };

    // 动画循环
    const animate = () => {
      texts.forEach((text, index) => {
        const rect = text.getBoundingClientRect();
        let x = parseFloat(text.style.left);
        let y = parseFloat(text.style.top);

        // 更新位置
        x += text.speedX;
        y += text.speedY;

        // 边界碰撞检测
        if (x <= 0 || x >= window.innerWidth - rect.width) {
          text.speedX = -text.speedX * 0.8;
          x = Math.max(0, Math.min(x, window.innerWidth - rect.width));
          text.style.color = `hsl(${Math.random() * 360}, 70%, 50%)`;
        }
        if (y <= 0 || y >= window.innerHeight - rect.height) {
          text.speedY = -text.speedY * 0.8;
          y = Math.max(0, Math.min(y, window.innerHeight - rect.height));
          text.style.color = `hsl(${Math.random() * 360}, 70%, 50%)`;
        }

        // 文字间碰撞检测
        for (let i = index + 1; i < texts.length; i++) {
          if (checkCollision(text, texts[i])) {
            handleCollision(text, texts[i]);
          }
        }

        // 添加重力效果
        text.speedY += 0.02;

        // 限制最大速度
        const maxSpeed = 5;
        if (Math.abs(text.speedX) > maxSpeed) {
          text.speedX = text.speedX > 0 ? maxSpeed : -maxSpeed;
        }
        if (Math.abs(text.speedY) > maxSpeed) {
          text.speedY = text.speedY > 0 ? maxSpeed : -maxSpeed;
        }

        text.style.left = `${x}px`;
        text.style.top = `${y}px`;
      });

      requestAnimationFrame(animate);
    };

    animate();

    // 鼠标交互
    const handleMouseMove = (e) => {
      texts.forEach(text => {
        const rect = text.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        
        const distance = Math.sqrt(
          Math.pow(e.clientX - centerX, 2) + Math.pow(e.clientY - centerY, 2)
        );
        
        if (distance < 100) {
          const force = (100 - distance) / 100;
          const angle = Math.atan2(centerY - e.clientY, centerX - e.clientX);
          text.speedX += Math.cos(angle) * force * 0.5;
          text.speedY += Math.sin(angle) * force * 0.5;
        }
      });
    };

    container.addEventListener('mousemove', handleMouseMove);

    // 清理函数
    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      texts.forEach(text => {
        if (text.parentNode) {
          text.parentNode.removeChild(text);
        }
      });
    };
  }, []);

  return (
    <div className="zsbzs-container" ref={containerRef}>
      <div className="zsbzs-background">
        <h1 className="zsbzs-title">zsb&cms</h1>
      </div>
    </div>
  );
};

export default Zsbzs;